import "../assets/styles/LoginPage.css";
import dcLogo from '../assets/img/logo.svg';

export default function LoginPage({ children }) {
    return (
        <div className="loginPage">
            <div className="loginCardWrapper">
                <div className="loginCard">
                    <div className="loginCard__header">
                        <div className="loginCard__logo">
                            <img src={dcLogo} alt="Logo dc" width="45"
                                 height="45"/>
                        </div>
                    </div>
                    <div className="loginCard__content">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
